import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: "history",
	pageRouting: true,
	base: process.env.BASE_URL,
	scrollBehavior(e) {
		console.log(e)
		if ( e.query.scrollTop === undefined || e.query.scrollTop === true ) {
			document.querySelector('#wrap').scrollIntoView({ behavior: 'smooth' });
		}
	},
	routes: [
		{
			name: 'index',
			path: '/',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					path: '/',
					components: {
						'rv-container': () => import('@/pages/index')
					}
				},
			]
		},

		{
			name: 'sns',
			path: '/member',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPop')
			},
			children: [

				{
					// KAKAO 로그인 리턴 주소
					name: 'kakaoReturn',
					path: 'sns/kakaoReturn',
					components: {
						'rv-container': () => import('@/components/members/sns/kakaoReturn')
					}
				},
				{
					// KAKAO IOS 로그인 리턴 주소
					name: 'kakaoIOSReturn',
					path: 'sns/kakaoIOSReturn',
					components: {
						'rv-container': () => import('@/components/members/sns/kakaoIOSReturn')
					}
				},
				{
					// NAVER 로그인 리턴 주소
					name: 'naverReturn',
					path: 'sns/naverReturn/:coCode?/',
					components: {
						'rv-container': () => import('@/components/members/sns/naverReturn')
					}
				},
				{
					// NAVER IOS 로그인 리턴 주소
					name: 'naverIOSReturn',
					path: 'sns/naverIOSReturn/:coCode?/',
					components: {
						'rv-container': () => import('@/components/members/sns/naverIOSReturn')
					}
				},
				{
					// APPLE 로그인 주소
					name: 'appleReturn',
					path: 'sns/apple/:subDomain?/',
					components: {
						'rv-container': () => import('@/components/members/sns/appleReturn')
					}
				},
			]
		},

		{
			/**
			 * 로그인
			 * 회원가입
			 * 가입완료
			 * 인증메일
			 * 인증처리
			 */
			name: 'member',
			path: '/member',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					// 로그인
					name: 'login',
					path: 'login',
					components: {
						'rv-container': () => import('@/components/members/login')
					}
				},
				{
					// 회원가입 첫페이지
					name: 'joinStart',
					path: 'joinStart',
					components: {
						'rv-container': () => import('@/components/members/join/joinStart')
					}
				},
				{
					// 회원가입
					name: 'joinForm',
					path: 'joinForm',
					components: {
						'rv-container': () => import('@/components/members/join/joinForm')
					}
				},
				{
					// 가입완료
					name: 'joinDone',
					path: 'joinDone',
					components: {
						'rv-container': () => import('@/components/members/join/joinDone')
					}
				},
				{
					// 이메일 인증 완료
					name: 'joinAuth',
					path: 'joinAuth',
					components: {
						'rv-container': () => import('@/components/members/join/joinAuth')
					}
				},
				{
					// 아이디 찾기
					name: 'findId',
					path: 'findId',
					components: {
						'rv-container': () => import('@/components/members/find/findId')
					}
				},
				{
					// 비밀번호 찾기
					name: 'findPasswd',
					path: 'findPasswd',
					components: {
						'rv-container': () => import('@/components/members/find/findPasswd')
					}
				}
			]
		},

		{
			/**
			 * SSO 팝업 로그인 (uuid, gid, redirecturl 파라미터가 있을 때)
			 * 헤더/푸터 없이 로그인 폼만 표시
			 */
			name: 'loginPopup',
			path: '/member/loginPopup',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPop')
			},
			children: [
				{
					name: 'loginPopupContainer',
					path: '',
					components: {
						'rv-container': () => import('@/components/members/login')
					}
				}
			]
		},



		{
			/**
			 * 마이페이지
			 */
			name: 'mypage',
			path: '/mypage',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					// 마이페이지 메인페이지
					name: 'mypage',
					path: '',
					components: {
						'rv-container': () => import('@/components/mypage/index')
					}
				},
				{
					// 회원정보 수정
					name: 'infoForm',
					path: 'infoForm',
					components: {
						'rv-container': () => import('@/components/mypage/infoForm')
					}
				},
				{
					// 비밀번호 변경
					name: 'changePassword',
					path: 'changePassword',
					components: {
						'rv-container': () => import('@/components/mypage/changePassword')
					}
				},
				{
					// 나의구매/구매현황 리스트
					name: 'paymentState',
					path: 'paymentState',
					components: {
						'rv-container': () => import('@/components/mypage/paymentState')
					}
				},
				{
					// 나의구매/구매현황 상세
					name: 'paymentDetail',
					path: 'paymentDetail/:oid',
					components: {
						'rv-container': () => import('@/components/mypage/paymentDetail')
					}
				}
			]
		},


		{
			// Trend
			name: 'trend',
			path: '/trend',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					// 뉴스피드
					name: 'trend-newsfeeds',
					path: 'newsfeeds',
					components: {
						'rv-container': () => import('@/pages/trend/newsfeeds')
					}
				},
				{
					// 이벤트
					name: 'trend-event',
					path: 'event',
					components: {
						'rv-container': () => import('@/pages/trend/event')
					}
				},
				{
					// 성공사례
					name: 'trend-success_examples',
					path: 'success_examples',
					components: {
						'rv-container': () => import('@/pages/trend/success_examples')
					}
				},
			]
		},





		{
			// Support Services
			name: 'support-services',
			path: '/support-services',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage'),
			},
			children: [
				{
					// 설치가이드
					name: 'guide_install',
					path: 'guide_install',
					components: {
						'rv-container': () => import('@/pages/support_services/guide_install')
					}
				},
				{
					// 기능가이드
					name: 'guide_function',
					path: 'guide_function',
					components: {
						'rv-container': () => import('@/pages/support_services/guide_function')
					}
				},
				{
					// FAQ
					name: 'faq',
					path: 'faq',
					components: {
						'rv-container': () => import('@/pages/support_services/faq')
					}
				},
			],
		},





		{
			// E-Learning Services
			name: 'e-learning-services',
			path: '/e-learning-services',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage'),
			},
			children: [

				{
					// 건축: architecture
					// 검설: construction
					// 엔지니어링: engineering
					name: 'el-services',
					path: ':cateCode/:cateName',
					components: {
						'rv-container': () => import('@/pages/elearning_services/el_services')
					}
				},

			],
		},





		{
			// Professional Services
			name: 'professional-services',
			path: '/app/professional-services',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage'),
			},
			children: [
				{
					// SW 개발사례
					name: 'sw_examples',
					path: 'sw_examples',
					components: {
						'rv-container': () => import('@/pages/professional_services/sw_examples')
					}
				},
				{
					// 컨설팅 서비스
					name: 'consulting_services',
					path: 'consulting_services',
					components: {
						'rv-container': () => import('@/pages/professional_services/consulting_services')
					}
				},
			],
		},










		{
			// 커뮤니티
			name: 'community',
			path: '/community',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					// 커뮤니티 공개
					name: 'community-open',
					path: 'open',
					components: {
						'rv-container': () => import('@/pages/community/open')
					}
				},
				{
					// 플랫폼 요청사항
					name: 'community-secret',
					path: 'secret',
					components: {
						'rv-container': () => import('@/pages/community/secret')
					}
				},
			]
		},



		{
			// APPS
			name: 'app',
			path: '/app',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					// 전체검색
					path: 'searcher/:searchText',
					components: {
						'rv-container': () => import('@/components/searchers/appSearchers')
					}
				},
				{
					// 게시판
					path: 'board/:boardKey',
					components: {
						'rv-container': () => import('@/components/boards/appBoards')
					}
				},
				{
					// 제품 다운로드 상세
					name: 'productDownDetail',
					path: 'board/:boardKey/detail/:idx',
					components: {
						'rv-container': () => import('@/components/license/productDownDetail')
					}
				},
				{
					/**
					 * 교육메인
					 * target : main, mine
					 */
					path: 'education/main/:cateCode?/',
					components: {
						'rv-container': () => import('@/components/educations/appEducations')
					},
				},
				{
					/**
					 * 교육과정
					 * target : course, mine
					 */
					path: 'education/course/:cateCode?/',
					components: {
						'rv-container': () => import('@/components/educations/appEduCourses')
					},
				},
				{
					/**
					 * 교육 > 학습현황
					 * target : main, mine
					 */
					path: 'education/mine/:WISH_LIKE?',
					components: {
						'rv-container': () => import('@/components/educations/appMyEducations')
					},
				},
				{
					//  설계자동화 앱
					name: 'design_auto_app',
					path: 'shop/goods',
					components: {
						'rv-container': () => import('@/pages/professional_services/design_auto_app')
					}
				},
				{
					// 상품 상세
					name: 'goods_detail',
					path: 'shop/goods/:gid',
					components: {
						'rv-container': () => import('@/pages/professional_services/goods_detail'),
					}
				},
				{
					// 주문
					name: 'order_info',
					path: 'shop/order_info',
					components: {
						'rv-container': () => import('@/pages/professional_services/order/order_info')
					}
				},
				{
					// 주문 완료
					name: 'order_done',
					path: 'shop/order_info/order_done',
					components: {
						'rv-container': () => import('@/components/shop/order/orderDone')
					}
				},
				{
					// 장바구니
					name: 'cartList',
					path: 'shop/cartList',
					components: {
						'rv-container': () => import('@/pages/professional_services/cart/cart_list')
					}
				},
				// {
				// 	//  설계자동화 앱 : LIKE
				// 	path: 'shop/goods/:WISH_LIKE?',
				// 	components: {
				// 		'rv-container': () => import('@/pages/professional_services/design_auto_app')
				// 	},
				// },
				{
					// PG INICIS
					name: 'closePg',
					path: 'shop/closePg',
					components: {
						'rv-container': () => import('@/components/shop/order/pg/closePg')
					}
				},
				{
					// PG INICIS
					name: 'popupPg',
					path: 'shop/popupPg',
					components: {
						'rv-container': () => import('@/components/shop/order/pg/popupPg')
					}
				},
				{
					/**
					 * 정적페이지 표출
					 * 관리자 > 페이지 관리
					 */
					path: 'statics/:PAGE_CODE',
					components: {
						'rv-container': () => import('@/components/statics/appPage')
					},
				}
			]
		},

		{
			// Box Series
			name: 'box-series',
			path: '/box-series',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					// 라이선스 관리
					name: 'licenseManagement',
					path: 'licenseManagement',
					components: {
						'rv-container': () => import('@/components/license/licenseManagement')
					}
				},
				{
					// 팀원 상세
					name: 'crewMemberDetail',
					path: 'crewMemberDetail',
					components: {
						'rv-container': () => import('@/components/license/crewMemberDetail')
					}
				},
				{
					// 라이선스 상세
					name: 'licenseDetail',
					path: 'licenseDetail/:crewId/:productName',
					components: {
						'rv-container': () => import('@/components/license/licenseDetail')
					}
				},
				{
					// 계약 상세
					name: 'contractDetail',
					path: 'contractDetail/:crewId/:licenseId',
					components: {
						'rv-container': () => import('@/components/license/contractDetail')
					}
				},
				{
					// 제품 설치
					name: 'Install',
					path: 'product_download',
					components: {
						'rv-container': () => import('@/components/license/productInstall')
					}
				},
				{
					// 오프라인 인증신청
					name: 'offlineCertification',
					path: 'offlineCertification',
					components: {
						'rv-container': () => import('@/components/license/offlineCertification')
					}
				},
				{
					// 오프라인 인증신청 내역
					name: 'offlineCertificationHistory',
					path: 'offlineCertificationHistory',
					components: {
						'rv-container': () => import('@/components/license/offlineCertificationHistory')
					}
				}
			]
		},


		{
			// APP EDUCATION
			name: 'learning',
			path: '/learning',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPop')
			},
			children: [
				{
					// 교육 진행
					name: 'proceed',
					path: 'proceed/:emIdx/:userIdEnc/',
					components: {
						'rv-container': () => import('@/components/educations/answer/eduProceed')
					}
				}
			]
		},




		/*{
			/!**
			 * HTML 표출용 페이지
			 * 게시판, 정적페이지
			 * htmlCode={VALUE}
			 *!/
			name: 'htmlOpen',
			path: '/htmlOpen',
			components: {
				'rv-app': () => import('@/components/display/htmlOpen')
			},

		},*/



		{
			/**
			 * 팝업
			 *
			 */
			name: 'popupOpen',
			path: '/popup/:idx',
			components: {
				'rv-app': () => import('@/components/display/popupOpen')
			},

		},

		{
			/**
			 * 주소찾기
			 *
			 */
			name: 'postCode',
			path: '/postCode',
			components: {
				'rv-app': () => import('@/components/shop/order/postCode/postCode')
			},

		},









		{
			/**
			 * ERROR
			 * route 등록 외 다른 페이지 없는 페이지
			 */
			name: 'error',
			path: '/:catchAll(.*)',
			components: {
				'rv-app': () => import('@/components/layouts/layoutPage')
			},
			children: [
				{
					path: '/',
					components: {
						'rv-container': () => import('@/components/layouts/error')
					}
				},
			]
		},


	],
});
